import script from "./CRadioGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CRadioGroup.vue?vue&type=script&lang=ts&setup=true"

import "./CRadioGroup.vue?vue&type=style&index=0&id=c4829b88&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4829b88"]])

export default __exports__